import { AddProfessionalModal } from '@modules/admin/component/add-professional-modal/AddProfessionalModal';
import LoginSignUpModal from '~/modules/user/component/login-signup-modal/LoginSignUpModal';
import { ClientOnly } from 'remix-utils';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import {
    uiStateAtomLoginModalAuthSource,
    uiStateAtomLoginModalOpened,
    uiStateAtomLoginModalRedirect,
    uiStateAtomLoginModalTitle,
} from '~/modules-rocco/root/states/ui-state-login-modal-opened';
import { uiStateAtomAddProfessionalModalOpened } from '~/modules-rocco/root/states/ui-state-add-professional-modal-opened';
import { useLoginPromptOnPageView } from '~/modules-rocco/user/hook/use-login-prompt-on-page-view';

const SiteWideModals = () => {
    useLoginPromptOnPageView();
    const [loginModalOpened, setLoginModalOpened] = useAtom(
        uiStateAtomLoginModalOpened,
    );
    const title = useAtomValue(uiStateAtomLoginModalTitle);
    const authSource = useAtomValue(uiStateAtomLoginModalAuthSource);
    const [addProfessionalModalOpened, setAddProfessionalModalOpened] = useAtom(
        uiStateAtomAddProfessionalModalOpened,
    );
    const redirect = useAtomValue(uiStateAtomLoginModalRedirect);
    const setLoginModalRedirect = useSetAtom(uiStateAtomLoginModalRedirect);
    const closeLoginModal = () => {
        setLoginModalOpened(false);
        setLoginModalRedirect(undefined);
    };

    const handleAuthSuccess = () => {
        if (authSource === 'footer') {
            window.scrollTo({ top: 0, behavior: 'instant' });
        }
        closeLoginModal();
    };

    return (
        <ClientOnly fallback={''}>
            {() => (
                <>
                    {addProfessionalModalOpened && (
                        <AddProfessionalModal
                            onClose={() => setAddProfessionalModalOpened(false)}
                            isOpen={addProfessionalModalOpened}
                        />
                    )}
                    {loginModalOpened && (
                        <LoginSignUpModal
                            login={{
                                open: true,
                                onCancel: closeLoginModal,
                                onConfirm: closeLoginModal,
                                onAuthSuccess: handleAuthSuccess,
                                flow: null,
                                authSource: authSource || 'unknown',
                                redirect: redirect,
                                header: title,
                                subtitle:
                                    authSource === 'siteGate'
                                        ? 'Dream it, design it, build it. Like a Pro.'
                                        : undefined,
                            }}
                            forgotPassword={{
                                open: true,
                                onCancel: closeLoginModal,
                            }}
                        />
                    )}
                </>
            )}
        </ClientOnly>
    );
};

export default SiteWideModals;
